'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconHome = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactackleIcons = require('reactackle-icons');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* eslint-disable max-len */


var IconHome = exports.IconHome = function IconHome(props) {
  return _react2.default.createElement(_reactackleIcons.IconSvg, props, _react2.default.createElement('svg', {
    viewBox: '0 0 24 24'
  }, _react2.default.createElement('path', {
    d: 'M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z'
  })));
};
/* eslint-enable max-len */


IconHome.displayName = 'IconHome';